import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const initInfo = async () => {
  const formStore = useFormStore()
  const res = await fetchInfo()
  const { nationalityId, englishFullName, arabicFullName, identityNumber } = res

  formStore.draft.request = {
    ...formStore.draft.request,
    ...{
      applicantCurNationalityId: nationalityId,
      applicantEngFullName: englishFullName,
      applicantArbFullName: arabicFullName,
      applicantIdentityNumber: identityNumber,
      applicantUnUumber: identityNumber
    }
  }
}

export default async function () {
  const formStore = useFormStore()

  try {
    formStore.extraMap = {}
    await initInfo()
  } catch (error) {
    console.error('use761Preload', error)
  }
}
